import { readReactionApi } from 'api/messengerReactions/readReactionApi'

export const READ_REACTION = 'READ_REACTION' as const

export const readReactionAction = (
  messageUuid: string,
  reactionId: number,
  profileId: number,
  readAt: number
) => ({
  type: READ_REACTION,
  promise: () => readReactionApi(messageUuid),
  messageUuid,
  reaction: {
    id: reactionId,
  },
  profileId,
  readAt,
})
